module.exports = {"370281001":"阜安街道","370281002":"中云街道","370281004":"三里河街道","370281006":"九龙街道","370281007":"胶东街道","370281008":"胶北街道","370281009":"胶西街道","370281010":"胶莱街道","370281102":"李哥庄镇","370281105":"铺集镇","370281108":"里岔镇","370281111":"洋河镇","370281400":"胶州经济技术开发区","370281401":"大沽河省级生态旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370281.json
// module id = 1489
// module chunks = 0